import * as Usuario from './usuario';
import * as Cookie from './cookie';
import * as Logout from './logout';
import * as Logger from './logger'

export const Initialize = () => {
    $('.ingresar').click(function(){
        Login();
    });

    //Logger.Muestreo();
    
    if (Cookie.LeerCookie('cookieLogin') != ""){
        Relogin();
    }

    Usuario.VerificarUsuario();
};

export const Login = () => {
    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
}

function Relogin(){
    var toRelogin = mustRelogin();
    console.log(toRelogin);

    if (toRelogin){
        var tokenCookie =  Cookie.LeerCookie("token"); 
        var xvalueCookie =  Cookie.LeerCookie("xvalue"); 
        if (tokenCookie == null || !tokenCookie)
        {
            tokenCookie == "";
        }
        if (xvalueCookie == null || !xvalueCookie)
        {
            xvalueCookie = "";
        }
        /*if (tokenCookie != null && tokenCookie && xvalueCookie!= null && xvalueCookie)
        {*/

        var headers = { 'X-Token': tokenCookie || '', 'X-Value': xvalueCookie || '' };
            var data = {
                OrigenLoginTipoId: 1,
                AutenticacionTipoId: 1,
                IsRelogin: 1
            }
            jQuery.ajax({
                url: window.config.Statics.APILoginUrl +"/Usuario/ReLogin",
                type: 'post',
                dataType: "json",
                data: data,
                headers: headers,
                async: true,
                success: function (res, status, xhr) {
                    reloginHandler(res, status, xhr);
                },
                error: function (e) {
                    console.log("error: " + e.toString());
                    Logger.Error("Relogin | API Error ", e);
                }
            });
        
      /*}
        else
        {
            if ((tokenCookie == null && xvalueCookie == null) || (!tokenCookie && !xvalueCookie))
            {
                Logger.Error("Relogin | sin token ni xvalue" );
            }
            else
            {
                if (tokenCookie == null || !tokenCookie)
                {
                    Logger.Error("Relogin | sin token ",{"xvalue": xvalueCookie});
                }
                if (xvalueCookie == null || !xvalueCookie)
                {
                    Logger.Warn("Relogin | sin xvalue ", {"token": tokenCookie});
                }
            }

        }*/
    }
}

function mustRelogin() {

    var syncValue = Cookie.LeerCookie('syncLfLN');

    var cookieSalt = Cookie.LeerCookie('token');

    try {
        var result = true;
        var millisecBeforeRelogin = window.config.Statics.ReloginValidation;

        // Parseo cookie syncLfLN para que no tenga am/pm . 
        // Tengo que convertir la hora en formato de 24hrs y no de 12hrs . 
        // Cookie de ejemplo : 09/06/2017 06:52:46 p.m.
        if (syncValue.indexOf("/") > -1 && (syncValue.indexOf('a.m.') > -1 || syncValue.indexOf('p.m.') > -1)) {
            var arr_full_date = syncValue.split(" ");   // [0] : 09/06/2017 - [1] : 06:52:46 - [2] : p.m.

            // La fecha está en DD/MM/YYYY . La convierto a MM/DD/YYYY ; 
            var daysDate = arr_full_date[0];
            var arr_days = daysDate.split('/');
            var daysDate = arr_days[1] + '/' + arr_days[0] + "/" + arr_days[2];

            var time = convertTo24Hour(arr_full_date[1] + arr_full_date[2]);
            arr_full_date[1] = time;
            syncValue = daysDate + " " + arr_full_date[1]; // Vuelvo a armar la cookie con el date actualizado. 
        }
        // Fin 

        if (cookieSalt == '') {
            return false;
        }

        if (syncValue != '') {
            var syncDate = new Date(syncValue);
            if (isNaN(syncDate)) Logger.Error("Relogin | SyncDate Invalid Date => " + syncValue , e);
            if (new Date() < new Date(syncDate.getTime() - millisecBeforeRelogin)) {
                result = false;
            }
        }

        return result;

    } catch (e) {

        Logger.Error("Relogin | MustRelogin - Error restando fechas", { 'syncValue' : syncValue , 'Date' : new Date() });

        return false;

    }
}

function convertTo24Hour(time) {
    var hours = time.substr(0, 2);
    if(time.indexOf('a.m.') != -1 && hours == 12) {
        time = time.replace('12', '00');
    }
    if(time.indexOf('p.m.')  != -1 && hours < 12) {
        time = time.replace(hours, (parseInt(hours) + 12));
    }
    return time.replace(/(a.m.|p.m.)/, '');
}

function reMe(token, xvalue) {
    //var headers = { 'X-Token': Cookie.LeerCookie("token") || '', 'X-Value': Cookie.LeerCookie("xvalue") || '' };
    var headers = { 'X-Token': token, 'X-Value': xvalue};
    jQuery.ajax({
        url: window.config.Statics.APILoginUrl + "/Usuario/Me",
        type: 'post',
        dataType: "json",
        headers: headers,
        async: true,
        success: function (res, status, xhr) {            
            reMeHandler(res, token, xvalue);
        },
        error: function (e) {
            console.log("error: " + e.toString());
            Logger.Error("ReMe | Error ", e);
        }
    });
}

function reloginHandler(res, status, xhr)
{
    switch(res.code) {
        case "0000":
            var token = xhr.getResponseHeader("X-Token") || getTokenBodyHelper(res.response,1);
            var xvalue = xhr.getResponseHeader("X-Value") || getTokenBodyHelper(res.response,2);

            if ((res.code == "0000") && (token == null || xvalue == null || !token || !xvalue)) {
                Logger.Error("Relogin | Headers en null", 'Headers | ' + xhr.getAllResponseHeaders() + ' || ' + ' Response | ' + JSON.stringify(res));
            } else {
                // Solo hace ReMe si el servicio trajo Token y xValue.
                reMe(token, xvalue);
                top.frames['iLogout'].location.href = "https://passport.lanacion.com.ar/cifrador.aspx?pagina=" + window.location.origin + window.config.Statics.ReloginUrl;
            }
            break;
            
        case "0220" :
            Logger.Warn("Relogin | Token o xvalue Expirado", res );
            Logout.Logout();
            break;
            
        case "0221":
            Logger.Error("Relogin | Relogin 0221", res );
            break;

        default:
            Logger.Error("Relogin | Error ", res );
    }
};

function reMeHandler(res, token, xvalue)
{
    switch(res.code) {
        case "0000" :
            var usuario = JSON.parse(res.response);
            Cookie.SetXValue(xvalue);
            Cookie.SetToken(token);
            Cookie.SetupCookies(usuario.Usuario);
            break;
        case "0001" :
            Logger.Error("ReMe | Error Controlado ", JSON.stringify(res) );
            Logout.Logout();
            break;
        case "0002" :
            Logger.Error("ReMe | Token inválido ", JSON.stringify(res)); //{ 'response' : res ,  'tokens': { 'X-Token': Cookie.LeerCookie("token") || '', 'X-Value': Cookie.LeerCookie("xvalue") || '' }});
            Logout.Logout();
            break;
        default:
            Logger.Error("ReMe | Error (Handler) ", JSON.stringify(res) );
            Logout.Logout();
    }
};


function getTokenBodyHelper (res,position) {
    try
    {
        return (res.split("|")[position]);
    }
    catch (ex)
    {
        return null;
    }

}


// WEBPACK FOOTER //
// ./Statics/scripts/common/login.js